import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import FeedbackComp from './feedback';
import { withStyles } from "@material-ui/core/styles"

const ContinueButton = withStyles({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 20,
    padding: "0px 0px",
    border: "0.5px solid",
    lineHeight: 0.5,
    backgroundColor: "#002D55",
    borderColor: "#002D55",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "0 0 0 0.2rem rgba(0,123,255,.5)",
      borderColor: "#0062cc",
      boxShadow: "none"
    },
    //"&:active": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
    //  backgroundColor: "#002D55",
    //  borderColor: "#002D55"
    //},
    //"&:focus": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
    //}
  }
})(Button);

export default function WelcomeDialog(props) {
  return (
    <div >
      <Dialog
        onClose={props.handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        maxWidth='lg'
        style={{justify: "flex-start", display: "flex", marginLeft: "24.3%"}}
      >
        <DialogContent dividers >
        <Typography variant="h2">
            Hi {"clientName"}, Click 'Begin' below, if you are ready to start your virtual physiotherapy treatment session!
          </Typography>
          <Typography variant="h4">
            How it works: 
          </Typography>
          <Typography variant="h6">
            Train along with the videoplayer by following along on the screen of your smartphone, tablet, computer or broadcast it to your TV. 
          </Typography>
          <Typography variant="h6">
            In general no warm-up is required. You can train along from the beginning of the session. <br/>
            However we recommend that you prepare the equipment needed for the exercises.<br/>
            You can always pause your program if you need to and to restart the exercises, but it is not possible to fast forward or skip the exercises, as our algorithm tracks your compliance with the program.<br/>
            If you need to stop the exercise, press the alert notification icon in the upper right corner and provide feedback for the exercise, or simply flag the exercise for review of a in-person physiotherapist.
          </Typography>
          <Typography variant="h6">
            Equipment needed for your program:
            <list>
              {}
            </list>
          </Typography>
        </DialogContent>
        <DialogActions >
          <ContinueButton autoFocus onClick={props.handleClose}>
            Continue
          </ContinueButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
